module.exports = __webpack_public_path__ + "static/media/ios-er.a1e52535.png";